module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/~/aws-sdk/apis/cognito-idp-2016-04-18.paginators.json
// module id = 488
// module chunks = 4